/** @format */

$(function () {

    $.ajaxSetup({
        xhrFields: {
            withCredentials: true
        }
    });

    if ($(".profile-inbox").length > 0) {
        $(".msglink").on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);
            var viewlink = $this.data("link");
            
            $("#inboxMessageModal .modal-content").load(viewlink, function(data) {
                $("#inboxMessageModal").modal("handleUpdate");

                // as soon as page opens, mark it as read
                if ($this.parent().hasClass("font-weight-bold")) {
                    $this
                        .parent()
                        .removeClass("font-weight-bold")
                        .parent()
                        .find(".envelope")
                        .removeClass("fas")
                        .removeClass("fa-envelope")
                        .addClass("far")
                        .addClass("fa-envelope-open");
                }
            });
            $("#inboxMessageModal").modal();
        });

        $(document).on("bsconfirm.click", function(evt, data) {
            console.log(data);
            if (data && data.trigger && data.trigger === "inbox-delete") {
                if (data.result)
                    window.location.href =
                        window.app.hrefPrefix() +
                        "/" +
                        window.app.currentLanguage() +
                        "/profile/deleteinboxmsg/" + data.id+ "/?id=" +
                        data.id;
            }
        });
    }
});
